/**
 * The SMSWiser campaign group key: campaigns of one country that point at the
 * same tracker campaign (provider + tracker id) are one group; a campaign
 * without a tracker link is a group of its own. One formula for the SMSWiser
 * page (stats tabs) and the Drop Generator (master configs per group).
 * For Media Devoted | Created By Ciro Autiero
 */
import type { TrackerEnum } from "../../trackers/tracker-registry";

export interface GroupableCampaign {
  wiserId: number;
  /** Missing = VOLUUM (the catalog default). */
  trafficProvider?: TrackerEnum | null;
  trafficCampaignId?: string | null;
}

export function campaignGroupKey(c: GroupableCampaign): string {
  const tid = c.trafficCampaignId == null ? "" : String(c.trafficCampaignId).trim();
  return tid !== "" ? `${c.trafficProvider ?? "VOLUUM"}:${tid}` : `wiser-${c.wiserId}`;
}
